import { createContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TransferContext = /*#__PURE__*/createContext(null);
export const TransferContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [isInvitationModalOpen, setIsInvitationModalOpen] = useState(false);
  const [organization, setOrganization] = useState(null);
  const contextValue = {
    isInvitationModalOpen,
    setIsInvitationModalOpen,
    organization,
    setOrganization
  };
  return /*#__PURE__*/_jsx(TransferContext.Provider, {
    value: contextValue,
    "data-sentry-element": "unknown",
    "data-sentry-component": "TransferContextProvider",
    "data-sentry-source-file": "OrganizationTransferContext.tsx",
    children: children
  });
};